const googleForm = {
    en: "https://docs.google.com/forms/d/e/1FAIpQLSdt1TSeGWiiionN1WNNA04eAxpbg1uNiB5eCPd8S11rM5G7Tg/viewform?embedded=true",
    es: "https://docs.google.com/forms/d/e/1FAIpQLScjPz0NJlyOTmKDqh5anfBO4D6L62hjeqoRFu4tVWb3FTUNmQ/viewform?embedded=true",
    de: "https://docs.google.com/forms/d/e/1FAIpQLSeMPheRDdGljZ6VEAW4wc2gVwHct88Pw61Bqz7QHGOniQ4xBA/viewform?embedded=true"
};

export default googleForm;